/* rv-rails.js — the two things the Buy-it-again rail needs that a generic product card
 * cannot know: the line "Your size M · ordered in June", and a quick-add pill that adds
 * THAT size (brief §4.2).
 *
 * It decorates the theme's own card rather than forking it, so the card keeps its badges,
 * swatches, price and sale styling. The data comes from rv-rivo.js's Rivo order read, which
 * means it is customer data and therefore client-side only — the rail's HTML stays cacheable.
 *
 * Add-to-cart is the theme's own mechanism, copied from collection-quick-add-v8: POST
 * /cart/add.js with `sections` so the cart drawer re-renders, then the same `rendered-cart`
 * / `cart:updated` events the rest of the theme listens for.
 */
(function () {
  "use strict";
  var PLUS = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 5v14M5 12h14"></path></svg>';

  function addToCart(variantId) {
    var body = { items: [{ id: variantId, quantity: 1 }] };
    if (document.getElementById("shopify-section-cart-drawer")) {
      body.sections = "cart-drawer";
      body.sections_url = window.location.pathname;
    }
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
      .then(function (data) {
        if (data && data.sections) {
          Object.keys(data.sections).forEach(function (sid) {
            var c = document.getElementById("shopify-section-" + sid);
            if (c) c.innerHTML = data.sections[sid];
          });
        }
        [document, window, document.querySelector("cart-drawer")].forEach(function (t) {
          if (t) { try { t.dispatchEvent(new CustomEvent("rendered-cart", { bubbles: true })); } catch (e) {} }
        });
        document.dispatchEvent(new CustomEvent("cart:updated"));
        return true;
      });
  }

  /* Copy comes from the gate's settings (translatable in the homepage template); the month is
     formatted in the page's language from the order date, not Liquid's English month name. */
  var T = { size: "Your size [SIZE]", month: "ordered in [MONTH]", add_aria: "Add [TITLE] in size [SIZE] to bag", added: "Added" };
  try {
    var cfgEl = document.querySelector("script[data-rv-config]");
    var c = cfgEl && JSON.parse(cfgEl.textContent).copy;
    if (c) Object.keys(T).forEach(function (k) { if (c[k]) T[k] = c[k]; });
  } catch (e) {}
  function monthOf(o) {
    if (o.when) {
      try { return new Date(o.when + "T12:00:00").toLocaleString(document.documentElement.lang || "en", { month: "long" }); } catch (e) {}
    }
    return o.month || "";
  }

  function decorate(rail, orders) {
    var byHandle = {};
    orders.forEach(function (o) { if (o.handle && !byHandle[o.handle]) byHandle[o.handle] = o; });

    rail.querySelectorAll(".carousel__cell[data-recs-handle]").forEach(function (cell) {
      if (cell.hasAttribute("data-rv-done")) return;
      var o = byHandle[cell.getAttribute("data-recs-handle")];
      if (!o) return;
      cell.setAttribute("data-rv-done", "1");

      /* meta line — under the price, in the card's own text column */
      if (o.size || o.month) {
        var info = cell.querySelector(".card__information") || cell.querySelector(".card__content") || cell;
        var meta = document.createElement("div");
        meta.className = "rv-meta";
        meta.textContent = [o.size ? T.size.replace(/\[size\]/i, o.size) : null, monthOf(o) ? T.month.replace(/\[month\]/i, monthOf(o)) : null]
          .filter(Boolean).join(" · ");
        info.appendChild(meta);
      }

      /* quick-add pill — bottom-right of the image, adds the size she bought */
      if (!o.variant_id || !o.size) return;
      /* The card's .full-unstyled-link covers the whole card, and anything placed INSIDE
         .card__media loses the click to it (the documented quick-add v8 see-saw: raising
         .card__media above the link is what breaks image-click -> PDP). So the pill is a
         SIBLING of the media inside .card__inner, positioned against the media's box and
         re-measured on resize. Image still navigates; only the pill's own 36px is taken. */
      var media = cell.querySelector(".card__media") || cell.querySelector(".media");
      var inner = cell.querySelector(".card__inner") || (media && media.parentElement);
      if (!media || !inner) return;
      if (getComputedStyle(inner).position === "static") inner.style.position = "relative";
      function place(el) {
        var top = media.offsetTop + media.offsetHeight - 36 - 8;
        el.style.top = top + "px";
      }
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "rv-pill";
      btn.setAttribute("aria-label", T.add_aria.replace(/\[title\]/i, o.title || "").replace(/\[size\]/i, o.size));
      btn.innerHTML = PLUS + " <span>" + o.size + "</span>";
      btn.addEventListener("click", function (e) {
        e.preventDefault(); e.stopPropagation();
        if (btn.disabled) return;
        btn.disabled = true;
        var label = btn.innerHTML;
        btn.innerHTML = "<span>Adding…</span>";
        addToCart(o.variant_id)
          .then(function () { btn.innerHTML = "<span>" + T.added + "</span>"; setTimeout(function () { btn.innerHTML = label; btn.disabled = false; }, 1600); })
          .catch(function () { btn.innerHTML = label; btn.disabled = false; });
      });
      inner.appendChild(btn);
      place(btn);
      if (typeof ResizeObserver !== "undefined") new ResizeObserver(function () { place(btn); }).observe(media);
    });
  }

  /* DEMO ONLY. Rivo is not installed on DEV, so ?rv=d has no order history. Rather than
     invent handles that do not exist on this store, synthesise the order lines FROM the
     cells the rail actually rendered: a real product, a real in-stock variant, a plausible
     month. Never runs when Rivo is present. */
  function demoOrders(rail) {
    var months = ["January", "March", "June", "August"];
    var out = [];
    rail.querySelectorAll(".carousel__cell[data-recs-handle]").forEach(function (cell, i) {
      if (i > 3) return;
      var json = cell.querySelector("script[data-recs-variants]");
      if (!json) return;
      var data; try { data = JSON.parse(json.textContent); } catch (e) { return; }
      var avail = (data.variants || []).filter(function (x) { return x.available; });
      /* a plausible demo size rather than whatever sorts first (which is always XXS) */
      var v = avail.filter(function (x) { return /^(M|S)$/i.test(x.label); })[0] || avail[0];
      if (!v) return;
      out.push({ handle: cell.getAttribute("data-recs-handle"), title: data.title,
                 variant_id: v.id, size: v.label, month: months[i % months.length] });
    });
    return out;
  }

  function watch(st) {
    /* orders come from the server (rv-variant-gate), so the pill does not wait for Rivo */
    if (st.code !== "C" && st.code !== "D") return;
    if (watch.done) return; watch.done = true;
    var rail = document.querySelector('[id$="__rail_buy_again"]');
    if (!rail) return;
    var run = function () {
      var orders = (window.RV && window.RV.state && window.RV.state.orders) || [];
      if (!orders.length && st.demo) orders = demoOrders(rail);
      if (orders.length) decorate(rail, orders);
    };
    run();
    document.addEventListener("rv:orders", run);
    /* the rail hydrates client-side, so the cells arrive after this script does */
    new MutationObserver(run).observe(rail, { childList: true, subtree: true });
  }

  var css = document.createElement("style");
  css.textContent =
    ".rv-meta{font-family:'TexGyreHerosCN','TeX Gyre Heros Cn',Helvetica,Arial,sans-serif;font-size:12px;line-height:18px;letter-spacing:.05em;color:#6b6b6b;margin-top:4px}" +
    ".rv-pill{position:absolute;right:8px;z-index:3;box-sizing:border-box;height:36px;padding:0 12px 0 10px;" +
    "display:inline-flex;align-items:center;gap:6px;background:#fff;border:0;border-radius:18px;" +
    "box-shadow:0 1px 6px rgba(0,0,0,.12);cursor:pointer;color:#000;" +
    "font-family:'TexGyreHerosCN','TeX Gyre Heros Cn',Helvetica,Arial,sans-serif;font-size:12px;letter-spacing:.05em}" +
    ".rv-pill[disabled]{opacity:.7;cursor:default}";
  document.head.appendChild(css);

  /* "Clear" on the recently-viewed rail — the rail reads Rivo's recently-viewed list
     (rivo_recently_viewed_product_ids), so clearing it also clears Rivo's own panel: the two
     stay identical. A localStorage wipe plus a reload, not a server call. */
  function wireClear() {
    var link = document.querySelector("[data-rv-clear]");
    if (!link) return;
    link.addEventListener("click", function (e) {
      e.preventDefault();
      ["rivo_recently_viewed_product_ids", "ob_recently_viewed", "ob_recently_viewed_v1", "recently_viewed"].forEach(function (k) {
        try { localStorage.removeItem(k); } catch (err) {}
      });
      location.reload();
    });
  }

  /* Visually turns the experiment on AFTER the page has loaded. By then the theme's carousels
     have initialised inside hidden sections and measured 0px, so the bands show headings over
     nothing until something triggers a resize (seen live on EU, 2026-10-21). When the switch
     flips on, nudge a resize a few times so every carousel re-measures in its now-visible box. */
  function remeasure() {
    [0, 250, 1000, 2500].forEach(function (ms) {
      setTimeout(function () { window.dispatchEvent(new Event("resize")); }, ms);
    });
  }
  function watchSwitch() {
    var d = document.documentElement;
    if (d.getAttribute("data-rv-variant") === "on") { remeasure(); return; }   // already on: one cheap re-measure covers an early-but-not-pre-paint switch
    var mo = new MutationObserver(function () {
      if (d.getAttribute("data-rv-variant") === "on") { mo.disconnect(); remeasure(); }
    });
    mo.observe(d, { attributes: true, attributeFilter: ["data-rv-variant"] });
  }
  watchSwitch();

  function start() {
    wireClear();
    if (window.RV) window.RV.onState(watch);
    else document.addEventListener("rv:state", function (e) { watch(e.detail); }, { once: true });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
